<template>
<div>
  <h3><icon type="cubes" class="mr-1" /> 3D {{ $t('parts') }}</h3>
  <hr class="panel-hr" />
  <loading-spinner v-if="loading"/>
  <canvas :id="nodeModelChartId" height="200" width="400"></canvas>
  <div class="lighter mt-3">{{ $t('dashboard.partsQuota') }}</div>
  <b>{{ makeLargeNumberHumanReadable(nodeModelAssetsLimit) }}</b><br/>
  <table class="panel-table mt-2 mb-2">
    <tr>
      <th class="label">{{ $t('dashboard.totalUniqueParts') }}</th>
      <th>{{ makeLargeNumberHumanReadable(nodeModelAssets) }}</th>
    </tr>
    <tr>
      <th class="label">{{ $t('dashboard.totalParts') }}</th>
      <th>{{ makeLargeNumberHumanReadable(totalInstances) }}</th>
    </tr>
    <tr>
      <th class="label">{{ $t('dashboard.totalRelevantParts') }}</th>
      <th>{{ makeLargeNumberHumanReadable(weightedFactor) }}</th>
    </tr>
  </table>
  <!--<span v-if="storage" class="lighter">{{ $t('usedComponents') }}</span>
  <h3>{{ nodeModelAssets }}</h3>-->
</div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {initChart} from "@/components/organizationDashboard/ChartHelper";
import Icon from "@/components/Icon.vue";
export default {
  name: "ComponentsPanel",
  components: {LoadingSpinner, Icon},
  props: {
    organizationId: {type: String, required:true},
    autoLoad: {type: Boolean, default: false},
    nodeModelAssetsLimit: {type: Number, default: 100000},
  },
  data() {
    return {
      nodeModelAssets: 0,
      totalInstances: 0,
      weightedFactor: 0,
      storage: null,
      loadingStorageUsage: false,
      loading: false,
      nodeModelChartId: 'nodeModelChart_' + Math.random().toString(36).substring(7),
    };
  },
  beforeMount() {
    if (this.autoLoad) {
      this.loadAssetNumbers();
    }
  },
  methods: {
      makeLargeNumberHumanReadable(number) {
        const string = number.toString();
        let stringArray = [];
        for (let i = 0; i < string.length; i++) {
          stringArray.push(string.charCodeAt(i));
        }
        let newString = '';
        let count = 0;
        for (let j = stringArray.length - 1; j >= 0; j--) {
          newString = String.fromCharCode(stringArray[j]) + newString;
          count++;
          if (count === 3 && j !== 0) {
            newString = "'" + newString;
            count = 0;
          }
        }
        return newString;
      },
      async loadAssetNumbers() {
        this.loading = true;
        return this.$store.dispatch('clientLoadAssetsCount', {
          filter: 'type in node model helper,organizationId eq ' + this.$route.params.id,
        }).then(async res => {
          const nodeModelAssets = res && res.count ? res.count : 0;
          await this.load3DInstances();
          const calculated = (nodeModelAssets * 2) + (this.totalInstances ? this.totalInstances : 0);
          this.weightedFactor = (calculated / 3).toFixed(0);
          this.nodeModelAssets = nodeModelAssets;
          this.nodeModelChart = this.initChart(this, this.nodeModelChart,
              {
                chartId: this.nodeModelChartId,
                limit: this.nodeModelAssetsLimit,
                total: this.nodeModelAssets,
                labels: [this.$t('dashboard.partsQuotaLeft'), this.$t('dashboard.used')]
              }
          );
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    async load3DInstances() {
      return await this.$store.dispatch('clientLoadOrganizationInstances', {
        id: this.$route.params.id,
        filter: 'type in node model assembly',
      }).then(data => {
        this.totalInstances = data.count ? data.count : 0;
      }).catch(e => {
        console.log('total instances error', this.totalInstances);
        console.log(e);
      })
    },
    initChart,
    /***
     * Loads the storage for a given organization
     * */
    async loadStorageUsage() {
      this.loadingStorageUsage = true;
      return this.$store.dispatch('clientListStorageUsage', {
        id: this.$route.params.id
      }).then(data => {
        if (data && data.body) {
          this.storage = data.body.readableSize;
          this.storageNumber = data.body.size
        }
        this.loadingStorageUsage = false;
        if (this.$store.getters.isSFXMember || this.$store.getters.isSuperAdmin) {
          this.storageChart = this.initChart(this, this.storageChart,
              {
                chartId: this.storageChartId,
                limit: this.storageLimit,
                total: this.storageNumber,
                labels: ['Storage Limit', 'Used Storage']
              });
        }
      }).catch(() => {
        this.loadingStorageUsage = false;
      });
    },
  }
}
</script>

<style lang="scss">
.panel-table {
  max-width: 100%;
  td {
    min-width: none;
  }
  .label {
    width: 70%;
  }
}
</style>